import React, { useState, useRef } from "react";
import { Close } from "@mui/icons-material";
import headerImage from "~/images/modal-background-image.png";
import MixpanelService from "../utils/MixpanelService";
import useOutsideClick from "../Hooks/useOutsideClick";

const LeavePageModal = ({ leavePageLink, onClose }) => {
  const [loading, setLoading] = useState(false);

  const modalRef = useRef();
  useOutsideClick(modalRef, onClose);

  if (!leavePageLink) {
    return null;
  }

  const navigate = () => {
    setLoading(true);
    MixpanelService.track("Cancel Submission");
    location.href = leavePageLink;
  };

  return (
    <div className="tpa-modal__background">
      <div className="tpa-modal__container" ref={modalRef}>
        <div className="tpa-modal__header">
          <div className="tpa-modal__header__img">
            <img src={headerImage} width={145} />
          </div>
          <div className="button button--sq-md button--transparent" onClick={onClose}>
            <Close />
          </div>
        </div>
        <div className="tpa-modal__body">
          <div className="t--xl t--500">Discard Submission?</div>
          <div className="t--subtitle">
            Please confirm if you want to discard this submission. If you proceed, you will lose
            your current work. This cannot be undone.
          </div>
          <div className="flex justify-content-end gap--16">
            <button className="button button--lg button--white" onClick={onClose}>
              Cancel
            </button>
            <button className="button button--blue button--lg" onClick={navigate}>
              {loading ? <div className="loading-indicator"></div> : "Discard Submission"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LeavePageModal;
